import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { Cart, CartItemUpdate } from "@spare-cart/contracts/cart";
import { apiClient } from "@core/api";
import { cartKeys } from "@modules/shared";

export type UpdateCartItemInput = CartItemUpdate & { itemId: string };

export const useUpdateCartItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ itemId, ...body }: UpdateCartItemInput) =>
      apiClient.patch<Cart>(`/cart/items/${itemId}`, body),
    onSuccess: (cart) => {
      queryClient.setQueryData(cartKeys.detail(), cart);
      void queryClient.invalidateQueries({ queryKey: cartKeys.count() });
    },
  });
};
